import { startCase } from 'lodash';

import { ServiceType } from '@/gql/graphql';
import type { ListType } from '@/models/app';

import { fetchPaymentTiers } from './fetchPaymentTiers';

type PaymentTierRow = Awaited<ReturnType<typeof fetchPaymentTiers>>[number];

const formatPaymentTierLabel = (item: PaymentTierRow): string => {
  const codeLabel = startCase(item.code);

  if (item.service === ServiceType.Grocery && item.maxCharge != null) {
    return `${codeLabel} ($${item.chargePerOrder} ~ $${item.maxCharge})`;
  }

  if (item.chargePerUnit) {
    return `${codeLabel} ($${item.chargePerUnit} per ${item.unit})`;
  }

  if (item.chargePerOrder) {
    const unitLabel = item.service === ServiceType.Ride ? 'ride' : item.service === ServiceType.Gourmet ? 'order' : item.unit;
    return `${codeLabel} ($${item.chargePerOrder} per ${unitLabel})`;
  }

  return codeLabel;
};

export const mapPaymentTiersToOptions = (tiers: PaymentTierRow[]): ListType[] =>
  tiers.map((item, index) => ({
    id: index + 1,
    key: item.code,
    label: formatPaymentTierLabel(item),
  }));
